import toast from 'react-hot-toast';

const DEDUP_WINDOW_MS = 1500;
const recentToastMap = new Map();

const normalizeMessage = (message) => {
  if (typeof message === 'string') {
    return message.trim();
  }

  if (message === null || message === undefined) {
    return '';
  }

  return String(message);
};

const isRecentDuplicate = (id) => {
  const now = Date.now();
  const lastShownAt = recentToastMap.get(id);

  if (lastShownAt && now - lastShownAt < DEDUP_WINDOW_MS) {
    return true;
  }

  recentToastMap.set(id, now);
  return false;
};

const withDedup = (originalFn, type) => {
  return (message, options = {}) => {
    const normalizedMessage = normalizeMessage(message);
    const computedId = options.id || `${type}:${normalizedMessage}`;

    if (!normalizedMessage) {
      return originalFn(message, options);
    }

    if (isRecentDuplicate(computedId)) {
      return computedId;
    }

    return originalFn(message, {
      ...options,
      id: computedId,
    });
  };
};

toast.success = withDedup(toast.success, 'success');
toast.error = withDedup(toast.error, 'error');
toast.loading = withDedup(toast.loading, 'loading');
